import { z } from 'zod';

export const ProductInfoSchema = z.object({
  productId: z.number(),
  productNumber: z.number(),
  productName: z.string(),
});
export type ProductInfo = z.infer<typeof ProductInfoSchema>;
